<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <div class="content">
              <ValidationObserver
          v-slot="{ errors }"
          tag="div"
        >
          <input-form
            ref="form"
            :errors="errors"
            name="CommonAppForm"
            @submit.prevent="handleSubmit"
          >
          <img src="../assets/FreshStartPHLlogo.png" width="60%"/>
          <br>
          <div v-if="AcceptingApplications == true">
            <div id="tenant">
              <h2>Tenant Information</h2>
              <div class="columns">
                <div class="column">
                  <vee-textbox
                      id="txt-tenant-first-name"
                      v-model="Tenant.FirstName"
                      mode="eager"
                      name="txt-tenant-first-name"
                      placeholder="First Name"
                      rules="required"
                      required
                      error="This field is required"
                  />
                </div>
                <div class="column">
                  <vee-textbox
                      id="txt-tenant-last-name"
                      v-model="Tenant.LastName"
                      mode="eager"
                      name="txt-tenant-last-name"
                      placeholder="Last Name"
                      rules="required"
                      required
                      error="This field is required"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <vee-textbox
                      id="txt-tenant-email"
                      v-model="Tenant.Email"
                      mode="eager"
                      name="txt-tenant-email"
                      placeholder="Email"
                      rules="required|email"
                      required
                      error="This field is required"
                  />
                </div>
              </div>
            </div>
            <br>
            <div id="landlord">
              <h2>Landlord Information</h2>
                <div class="columns">
                  <div class="column">
                  <vee-radio
                      id="radio-active-landlord"
                      v-model="Landlord.ActiveLandlord"
                      :options="MultipleChoiceFieldOptions.YesNo"
                      label="Is there a landlord to reach out to at this time?"
                      rules="required"
                      required
                      @change="landlordRequired()"
                  />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                        id="txt-landlord-first-name"
                        v-model="Landlord.FirstName"
                        mode="eager"
                        name="txt-landlord-first-name"
                        placeholder="First Name"
                        :rules="landlordRequired()"
                        required
                    />
                  </div>
                  <div class="column">
                    <vee-textbox
                        id="txt-landlord-last-name"
                        v-model="Landlord.LastName"
                        mode="eager"
                        name="txt-landlord-last-name"
                        placeholder="Last Name"
                        :rules="landlordRequired()"
                        required
                    />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                        id="txt-landlord-email"
                        v-model="Landlord.Email"
                        mode="eager"
                        name="txt-landlord-email"
                        placeholder="Email"
                        :rules="landlordRequired() + '|email'"
                        required
                    />
                  </div>
                  <div class="column">
                    <vee-textbox
                        id="txt-landlord-company-name"
                        v-model="Landlord.CompanyName"
                        mode="eager"
                        name="txt-landlord-company-name"
                        placeholder="Company Name"
                    />
                  </div>
                </div>
              </div>
              <br>
              <div id="confirm">
                <h2>Confirmation</h2>
                <p>I confirm that this form is complete and accurate and ready to be reviewed by PHDC</p>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                        id="txt-confirm-signature"
                        v-model="Confirm.Signature"
                        mode="eager"
                        name="txt-confirm-signature"
                        placeholder="Signature"
                        rules="required"
                        required
                    />
                  </div>
                  <div class="column">
                    <vee-textbox
                        id="txt-confirm-date"
                        v-model="Confirm.Date"
                        mode="eager"
                        name="txt-confirm-date"
                        placeholder="Date"
                        rules="required"
                        required
                        type="date"
                    />
                  </div>
                </div>
              </div>
              <div class="column is-2 is-offset-10">
                <button
                  type="button"
                  class="button is-primary"
                  :disabled="SubmitStatus.Value == SubmitStatus.Options.PENDING"
                  @click="handleSubmit"
                >
                  Submit
                </button>
              </div>
          </div>
          <div v-else>
            <callout type="warning">
              Sorry, we are not currently accepting applications
            </callout>
          </div>
          </input-form>
        </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import options from "@/utilities/options";
import axios from "axios";
import buildApplicationSubmitDataObject from "@/utilities/data-objects/submit-application";
import buildAcceptingApplicationsCheckDataObject from "@/utilities/data-objects/accepting-applications-check";
import {
  dataObjectToXml,
  getPropertyValueOrDefault
 } from "@/utilities/functions";

export default {
  name: "HomePage",
  mixins: [options],
  data() {
    return {
      AcceptingApplications: null,
      Tenant:{
        FirstName: null,
        LastName: null,
        Email: null,
      },
      Landlord:{
        FirstName: null,
        LastName: null,
        Email: null,
        CompanyName: null,
        ActiveLandlord: null,
      },
      Confirm:{
        Signature: null,
        Date: null,
      }
    };
  },
  created(){
    var vData = this;
    const dataObject = buildAcceptingApplicationsCheckDataObject("COMMON_APP_ACCEPTING_APPLICATIONS_CHECK");
      const requestObj = {
        data: dataObject,
      };
      axios
        .post(
          process.env.VUE_APP_QB_API_URL+"accepting-applications-check",
          requestObj,
         ).then(qbResult => {
          const responseObject = getPropertyValueOrDefault(
              ["data", "record", "f"],
              qbResult
            );
            vData.AcceptingApplications = getPropertyValueOrDefault(
              ["_text"],
              responseObject.find(i => i._attributes.id === "11")
            );
            vData.AcceptingApplications = false;
            //console.log(vData.AcceptingApplications);
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
          // Handle successful submission response here
         }).catch(function(error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          }
        });
  },
  methods: {
    landlordRequired(){
      if(this.Landlord.ActiveLandlord === "No"){
        this.updateRequiredField("tb-txt-landlord-first-name", false, "First Name");
        this.updateRequiredField("tb-txt-landlord-last-name", false, "Last Name");
        this.updateRequiredField("tb-txt-landlord-email", false, "Email");
        return "";
      }
      else{
        this.updateRequiredField("tb-txt-landlord-first-name", true, "First Name");
        this.updateRequiredField("tb-txt-landlord-last-name", true, "Last Name");
        this.updateRequiredField("tb-txt-landlord-email", true, "Email");
        return "required";
      }
    },
    updateRequiredField(elementId, isRequired, text){
      const element = document.getElementById(elementId);
      if(element){
        element.required = isRequired;
        element.placeholder = text + (isRequired ? " *" : "");
        if(element.labels.length > 0){
          const label = document.querySelector(`label[for="${elementId}"]`);
          label.classList.toggle("hide-after", !isRequired);
          //element.labels[0].innerText = element.placeholder;
        }
      }
    },

    async handleSubmit() {
      // Handle form submission logic here
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const dataObject = buildApplicationSubmitDataObject(vData);
      const xmlDataObject = dataObjectToXml(dataObject);
      const requestObj = {
        data: xmlDataObject,
      };
      axios
        .post(
          process.env.VUE_APP_QB_API_URL+"submit",
          requestObj,
         ).then(() => {
          //console.log(qbResult);

          vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
          // Handle successful submission response here
          this.$router.push({
            name: "Success",
          });
         }).catch(function(error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          }
        });
          // Handle error response here
    },
  },
};
</script>

<style>
label.hide-after::after {
  display: none;
}
</style>